import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./panchang.css";

function DailyPanchang() {
  const today = new Date();
  const defaultDate = `${String(today.getDate()).padStart(2, "0")}/${String(
    today.getMonth() + 1
  ).padStart(2, "0")}/${today.getFullYear()}`;
  const defaultTime = `${String(today.getHours()).padStart(2, "0")}:${String(
    today.getMinutes()
  ).padStart(2, "0")}`;

  const [params, setParams] = useState({
    date: defaultDate,
    time: defaultTime,
    latitude: "24",
    longitude: "76",
    tz: "5.5",
  });

  const [language, setLanguage] = useState("en");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Fetch Panchang data
  const fetchDailyPanchang = () => {
    setLoading(true);
    setError("");
    setResult(null);

    fetch(
      `https://api.jyotishamastroapi.com/api/panchang/panchang?date=${params.date}&time=${params.time}&latitude=${params.latitude}&longitude=${params.longitude}&tz=${params.tz}&lang=${language}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          key: "2a10JhmcIyTL81Pivmzo92ynCeS04v",  
        },
      }
    )
      .then((res) => {
        if (!res.ok) throw new Error(`API Error: ${res.status}`);
        return res.json();
      })
      .then((data) => setResult(data.response || data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };

  // ✅ Automatically fetch Panchang on component mount
  useEffect(() => {
    fetchDailyPanchang();
  }, []);

  return (
    <div className="container">
      <div className="ra-main-DailyPanchang">

        {/* Top Buttons */}
        <div
          className="DailyPanchang-top-buttons"
          style={{
            marginBottom: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            {/* Calendar Logo SVG */}
            <svg
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              style={{ marginRight: "0.75rem" }}
            >
              <rect
                x="3"
                y="5"
                width="18"
                height="16"
                rx="2"
                stroke="#333"
                strokeWidth="2"
                fill="#f5f5f5"
              />
              <path
                d="M16 3v4M8 3v4"
                stroke="#333"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path d="M3 9h18" stroke="#333" strokeWidth="2" />
            </svg>

            
            <Link to="/MonthlyPanchang" style={{ textDecoration: "none", marginRight: "10px" }}>
              <button type="button">📅 Monthly Panchang</button>
            </Link>

            <Link to="/Hora" style={{ textDecoration: "none", marginRight: "10px" }}>
              <button type="button">Hora</button>
            </Link>
            <Link to="/Choghadiya" style={{ textDecoration: "none",marginRight: "10px"  }}>
              <button type="button">Choghadiya</button>
            </Link>
           
          </div>
        </div>

        {/* Main Title */}
        <h2>🕉 Daily Panchang</h2>

        {/* Input + Language Selector */}
        <div className="DailyPanchang-inputs">
          <input
            type="text"
            value={params.date}
            onChange={(e) => setParams({ ...params, date: e.target.value })}
            placeholder="Date (DD/MM/YYYY)"
          />
          <input
            type="text"
            value={params.time}
            onChange={(e) => setParams({ ...params, time: e.target.value })}
            placeholder="Time (HH:MM)"
          />
          <select
            className="DailyPanchang-lang"
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
          >
            <option value="en">English</option>
            <option value="hi">Hindi</option>
            <option value="be">Bengali</option>
            <option value="ta">Tamil</option>
            <option value="te">Telugu</option>
            <option value="ka">Kannada</option>
            <option value="ml">Malayalam</option>
            <option value="mr">Marathi</option>
            <option value="gr">Gujarati</option>
          </select>
          <button onClick={fetchDailyPanchang} disabled={loading}>
            {loading ? "Loading..." : "Get Daily Panchang"}
          </button>
        </div>

        {/* Error */}
        {error && <p className="DailyPanchang-error-text">❌ {error}</p>}

        {/* Panchang Result */}
        {result && (
          <div className="DailyPanchang-result">
            <div className="DailyPanchang-card highlight">
              <h3>📅 Date: {result.date}</h3>
              <h1><strong>Day:</strong> {result.day?.name}</h1>
              <h1><strong>Rashi:</strong> {result.rasi?.name}</h1>
            </div>

            <div className="DailyPanchang-grid">
              {/* Tithi */}
              <div className="DailyPanchang-card">
                <h4>🌙 Tithi</h4>
                <p><strong>Name:</strong> {result.tithi?.name}</p>
                <p><strong>Type:</strong> {result.tithi?.type}</p>
                <p><strong>Start:</strong> {result.tithi?.start}</p>
                <p><strong>End:</strong> {result.tithi?.end}</p>
                <p>{result.tithi?.meaning}</p>
              </div>

              {/* Nakshatra */}
              <div className="DailyPanchang-card">
                <h4>✨ Nakshatra</h4>
                <p><strong>Name:</strong> {result.nakshatra?.name}</p>
                <p><strong>Lord:</strong> {result.nakshatra?.lord}</p>
                <p><strong>Start:</strong> {result.nakshatra?.start}</p>
                <p><strong>End:</strong> {result.nakshatra?.end}</p>
                <p>{result.nakshatra?.meaning}</p>
              </div>

              {/* Yoga */}
              <div className="DailyPanchang-card">
                <h4>☀️ Yoga</h4>
                <p><strong>Name:</strong> {result.yoga?.name}</p>
                <p><strong>Meaning:</strong> {result.yoga?.meaning}</p>
                <p><strong>Start:</strong> {result.yoga?.start}</p>
                <p><strong>End:</strong> {result.yoga?.end}</p>
              </div>

              {/* Karana */}
              <div className="DailyPanchang-card">
                <h4>🌏 Karana</h4>
                <p><strong>Name:</strong> {result.karana?.name}</p>
                <p><strong>Type:</strong> {result.karana?.type}</p>
                <p><strong>Start:</strong> {result.karana?.start}</p>
                <p><strong>End:</strong> {result.karana?.end}</p>
              </div>

              {/* Important Timings */}
              <div className="DailyPanchang-card timings">
                <h4>🕰 Important Timings</h4>
                <p><strong>Sunrise:</strong> {result.advanced_details?.sun_rise}</p>
                <p><strong>Sunset:</strong> {result.advanced_details?.sun_set}</p>
                <p><strong>Moonrise:</strong> {result.advanced_details?.moon_rise}</p>
                <p><strong>Moonset:</strong> {result.advanced_details?.moon_set}</p>
                <p><strong>Rahukaal:</strong> {result.rahukaal}</p>
                <p><strong>Gulika:</strong> {result.gulika}</p>
                <p><strong>Yamakanta:</strong> {result.yamakanta}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default DailyPanchang;
